{
  "pt": {
    "installment": {
      "actions": {
        "bulkEdit": {
          "detail": "Editar detalhes",
          "reminder": "Editar lembretes"
        },
        "closeAllRows": "Fechar todas as linhas",
        "deleteCount": "Está prestes a eliminar {count} prestação. Tem a certeza? | Está prestes a eliminar {count} prestações. Tem a certeza?",
        "delete_installments": "Eliminar prestação | Eliminar prestações",
        "edit": "Editar",
        "newInstallment": "Nova fase de pagamento",
        "openAllRows": "Abrir todas as linhas",
        "publish": "Publicar",
        "publishCustomer": "Publicar...",
        "save": "Atualizar",
        "unpublish": "Cancelar a publicação",
        "updateStatus": "Atualizar o estado",
        "uploadInvoice": "Carregar fatura"
      },
      "attributes": {
        "amount": "Montante",
        "customer": "Cliente",
        "description": "Descrição",
        "due_date": "Data de vencimento",
        "group_name": "Fase de pagamento",
        "paid_at": "Pago em",
        "status_deadline": "Estado",
        "unit": "Unidade"
      },
      "edit_actions": {
        "edit_amount": "Montantes",
        "edit_deadline": "Data de vencimento",
        "edit_description": "Descrição",
        "edit_status": "Estado"
      },
      "labels": {
        "cantEditFractions": "Defina o estado da prestação como Rascunho para editar as regras.",
        "changeStatusRequested": "Alterar prestações do estado \"Rascunho\" para \"Faturado\"",
        "changeVisibility": "Alterar a visibilidade...",
        "change_amounts": "Modificar montantes",
        "clear_due_date": "Remover data de vencimento para todas as prestações selecionadas",
        "clear_paid_at": "Remover data de pagamento para todas as prestações selecionadas",
        "countEdit": "Editar prestação para 1 unidade | Editar prestação para {count} unidades",
        "created_at": "Criado {created_at}",
        "deleteExplanation": "Todas as prestações e faturas serão definitivamente retiradas da plataforma.",
        "deleteExplanationGroup": "Como pretende remover todas as prestações deste grupo de prestações, o grupo de prestações também será removido.",
        "details": "Detalhes",
        "edit": "Editar prestações",
        "editDueDate": "Editar data de vencimento",
        "editInstallmentTerm": "Editar prestação",
        "excl_vat": "sem IVA",
        "giveNewAmount": "Indicar novo montante",
        "goToUnitInstallments": "Ir para as prestações unitárias",
        "installmentNoteExplainer": "Esta nota só é visível para os membros da equipa.",
        "installment_categories": "Categorias personalizadas",
        "invoices": "1 fatura | {count} faturas",
        "new_installment_fraction_category": "Categoria",
        "noDeadline": "Sem data de vencimento",
        "notPublished": "Não publicado",
        "paid": "Pago",
        "published": "Publicado",
        "publishedCustomer": "Publicado para o cliente",
        "publishingForCustomers": "Tem a certeza?",
        "selectOne": "Selecionar pelo menos 1 prestação",
        "selected": "{selected} prestação selecionada. | {selected} prestações selecionadas.",
        "setDueDate": "Definir data de vencimento",
        "statusExplained": "O que significa cada estado da prestação?",
        "status_click_to_change": "Clique para alterar",
        "status_deadline": "Estado",
        "statuses": {
          "draft": "Rascunho",
          "expected": "Esperado",
          "overdue": "Atrasado",
          "paid": "Pago",
          "requested": "Faturado"
        },
        "toBePaid": "A pagar",
        "total": "Total",
        "unitInstallmentsWillBeShownHere": "As prestações unitárias serão apresentadas aqui",
        "unpublishingForCustomers": "Anular a publicação de prestações para o cliente. Tem a certeza?",
        "updateStatusCount": "Atualizar o estado de 1 prestação | Atualizar o estado de {count} prestações",
        "uploadInvoiceCount": "Carregar fatura para 1 prestação | Carregar fatura para {count} prestações",
        "uploadInvoiceUnit": "Carregar a fatura para {unit_name}",
        "vat": "IVA",
        "vat_with_percentage": "{percentage}% IVA",
        "view_list": "Lista"
      },
      "legend": {
        "installmentDraft": "Prestação em rascunho",
        "installmentDraftAfterDueDate": "Prestação em rascunho",
        "installmentExpired": "Data de vencimento expirada",
        "installmentPaid": "Prestação já paga",
        "installmentPaidAfterDue": "Prestação paga após o vencimento",
        "installmentRequested": "Faturado",
        "reminders": {
          "active": "Pelo menos 1 lembrete foi definido",
          "none": "Não foram definidos lembretes"
        }
      },
      "placeholders": {
        "customers": {
          "documents": {
            "subtitle": "Todos os documentos de prestação serão apresentados aqui.",
            "title": "Ainda não há documentos!"
          },
          "new": {
            "subtitle": "Em breve, novas prestações!"
          }
        }
      },
      "sort_options": {
        "due_date": "Data de vencimento",
        "due_date asc": "Data de vencimento mais distante primeiro",
        "due_date desc": "Data de vencimento mais próxima primeiro",
        "group_name": "Nome",
        "group_name asc": "Nome A-Z",
        "group_name desc": "Nome Z-A",
        "status": "Estado",
        "status asc": "Estado A-Z",
        "status desc": "Estado Z-A",
        "updated_at asc": "Atualização mais recente primeiro",
        "updated_at desc": "Atualização mais antiga primeiro"
      },
      "validation": {
        "needNumber": "Necessita de um número (por exemplo, 8400.5)"
      }
    }
  }
}
